module.exports = __webpack_public_path__ + "static/media/34_A.dbbf4ccb.png";